export default class IndustrymcntService {
  getAll() {
    return fetch("https://api.tradersr.com/api/industrymcnt")
      .then(res => res.json());
  }
}